<div mat-dialog-content>
    <div class="mat-dialog-content">
        <app-signature-manager [isMenu]="false" [isLoading]="isLoading" [isVisible]="true" (closeManager)="close()"
            (cancelSignature)="cancelSigning()" (submitSignature)="submit($event)">
        </app-signature-manager>
    </div>
</div>